import * as S from "../styles";
import GooglePOI from "./GooglePOI";
import MapGLPOI from "./MapGLPOI";
import { POIs as P } from "@local-logic/client";
import { LoadingItem } from "@local-logic/core/ui";
import { ScorePOIs } from "@local-logic/elements-react";
import React from "react";
import { useStateManagerContext } from "~/context/stateManager";
import { usePois } from "~/sdks/LocalContent/features/usePois";
import { LocalContentProps } from "~/sdks/LocalContent/types";

interface POIsProps {
  include: (keyof P)[];
}

const POIs = React.memo(({ include }: POIsProps) => {
  const result = usePois();
  const poisWithResults = include?.filter(
    (poi) => (result?.data?.[poi] ?? [])?.length > 0
  );
  const { sdkState } = useStateManagerContext<LocalContentProps>();
  const isGoogleMapProvider = sdkState.options?.mapProvider === "google";

  if (result.isLoading && poisWithResults?.length) {
    return (
      <>
        {[...Array(10)]?.map((_, i) => (
          <S.LoadingItemContainer key={i}>
            <LoadingItem height="34px" width="100%" />
          </S.LoadingItemContainer>
        ))}
      </>
    );
  }

  if (!result.data) {
    return null;
  }

  return (
    <ScorePOIs.Root options={{ include: poisWithResults }}>
      <ScorePOIs.Tabs />
      {poisWithResults?.map((poi) =>
        isGoogleMapProvider ? (
          <GooglePOI key={poi} poi={poi} result={result} />
        ) : (
          <MapGLPOI key={poi} poi={poi} result={result} />
        )
      )}
    </ScorePOIs.Root>
  );
});

POIs.displayName = "POIs";

export default POIs;
